var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
  * Listens for a popup event, and renders popup with the content.
  */
let QboPopupListener = class QboPopupListener extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
        this.loading = false;
        this.renderInHost = false;
        this.title = "Popup";
        this.eventName = 'qbo-popup';
        /* If true, call target.addEventListener to listen for any click events. */
        this.listen = true;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }
    toggle() {
        this.open = !this.open;
        if (this.open)
            document.addEventListener('click', this.handleOutsideClick);
        else
            document.removeEventListener('click', this.handleOutsideClick);
    }
    show() {
        this.open = true;
        document.addEventListener('click', this.handleOutsideClick);
    }
    hide(event) {
        if (event.target.closest('[data-dismiss="modal"]')) {
            this.open = false;
            this.src = null;
            const iframe = this.querySelector('iframe') ?? this.renderRoot.querySelector('iframe');
            if (iframe != null)
                iframe.removeAttribute('src');
            document.removeEventListener('click', this.handleOutsideClick);
        }
    }
    handleOutsideClick(event) {
        //    if (this.open && !this.contains(event.target)) {
        //        this.open = false;
        //        document.removeEventListener('click', this.handleOutsideClick);
        //    }
    }
    firstUpdated() {
        const component = this;
        component.targetElement = document.querySelector(component.target) ?? document;
        // component.targetContainer = component.renderRoot.querySelector('iframe');
        component.targetContainer = component.querySelector('iframe') ?? component.renderRoot.querySelector('iframe');
        component.targetElement.addEventListener(component.eventName, (e) => {
            component.showElement(e.target);
        });
        if (component.listen) {
            component.targetElement.addEventListener('click', (e) => {
                const source = e.composedPath().find(el => el instanceof HTMLAnchorElement);
                if (source != null) {
                    source.dispatchEvent(new CustomEvent(this.eventName, { bubbles: true, composed: true }));
                    e.preventDefault();
                }
            });
        }
    }
    /* @description Sets the popup iframe.src to the el.src. */
    showElement(el) {
        // Handle Youtube watch vs embed
        this.src = el.href.replace('youtube.com/watch', 'youtube.com/embed');
        const iframe = this.querySelector('iframe') ?? this.renderRoot.querySelector('iframe');
        if (iframe != null) {
            iframe.src = this.src;
            this.show();
        }
    }
    render() {
        return html `
        <slot name="button" @click="${this.toggle}"></slot>
        <slot name="content" @click="${this.hide}" style="display:${this.open ? 'flex' : 'none'}">
            <link href="scripts/qbo4.css" rel="stylesheet">
            <div class="modal" tabindex="-1" role="dialog" style="display:block">
                <div class="modal-dialog modal-lg" role="document" style="width:960px; height:600px">
                    <div class="modal-content">
                        <div class="modal-body" style="height:500px">
                            <iframe src="${this.src}" title="${this.title}" frameborder="0" width="100%" height="100%" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </slot>
    `;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "open", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "renderInHost", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "src", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "title", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "clickSelector", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "eventName", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "target", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPopupListener.prototype, "listen", void 0);
QboPopupListener = __decorate([
    customElement('qbo-popup-listener')
], QboPopupListener);
export { QboPopupListener };
